// Toggle the menu open and close on mobile
export function initMenu() {
    const burger = document.querySelector('.gh-burger');
    if (!burger) return;
    burger.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.toggle('gh-head-open');
    });
}
